import logo from "./logo.svg";
import "./App.css";

function Response() {
  return (
    <div className="App">
      <div>
        <TopBar />
        <div style={{ height: "64px" }} />
        <MainCard />
        <EmailUs />
        <Footer />
      </div>
    </div>
  );
}
function TopBar() {
  let sections: any[] = [];
  let bookmarks: any = ["What_is_Game_On"];

  return (
    <div
      style={{
        position: "fixed",
        backdropFilter: "blur(8px)",
        zIndex: 100,
        width: "100vw",
        height: "64px",
        backgroundColor: "rgb(244,254,233,0.85)",
        boxShadow: "0px 0px 10px 1px rgba(0,0,0,0.5)",
      }}
    >
      <div
        style={{
          height: "100%",
          marginLeft: "64px",
          marginRight: "64px",
          flexDirection: "row",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          onClick={() =>
            (window.location.href = "https://web.thegameonapp.com/Home")
          }
          style={{ width: "100px", cursor: "pointer" }}
        >
          <img
            src={process.env.PUBLIC_URL + "favicon.ico"}
            style={{
              height: "44px",
              width: "44px",
              alignSelf: "center",
              display: "flex",
            }}
            className="App-logo"
            alt="logo"
          />
        </div>
        <div
          style={{
            width: "30vw",
            justifyContent: "space-between",
            display: "flex",
          }}
        >
          {sections.map((s, i) => {
            return (
              <span key={s} style={{ fontSize: "0.6em" }}>
                <a
                  style={{ color: "rgb(39,66,77)", textDecoration: "none" }}
                  href={
                    "#" +
                    (bookmarks[i] || s.replace(/ /g, "_").replace("!", ""))
                  }
                >
                  {" "}
                  {s}
                </a>
              </span>
            );
          })}
        </div>

        <div style={{ width: "100px", display: "flex" }}>
          <span style={{ color: "black", fontSize: "0.6em" }}>
            <a
              href="#contact"
              style={{ color: "rgb(39,66,77)", textDecoration: "none" }}
            >
              Game On!
            </a>
          </span>
        </div>
      </div>
    </div>
  );
}

function MainCard() {
  const params: any = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop as string),
  });
  // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
  let { title, error, msg } = params;
  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <div
        style={{
          width: "80vmin",
          height: "80vmin",
          backgroundColor: "green",
          backgroundSize: "cover",
          backgroundPosition: "center",
          marginTop: "64px",
          marginBottom: "64px",
          boxShadow: "0px 0px 10px 1px rgba(0,0,0,0.5)",
        }}
      >
        <div
          style={{
            position: "relative",
            height: "100%",
            width: "100%",
            backgroundColor: "rgba(255,255,255,0.9)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <img
            alt="logo"
            src={process.env.PUBLIC_URL + "AppFinal.png"}
            style={{ height: "100%", width: "100%" }}
          />
          <div
            style={{
              position: "absolute",
              height: "100%",
              width: "100%",
              backgroundColor: "rgba(255,255,255,0.95)",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <img
              src={logo}
              style={{
                height: `${1.08 * 3}vmin`,
                position: "absolute",
                width: `${5.68 * 3}vmin`,
                alignSelf: "center",
                top: "2vh",
                display: "flex",
                marginBottom: "2vmin",
              }}
              className="App-logo"
              alt="logo"
            />
            <span
              style={{
                width: "40%",
                textAlign: "center",
                fontSize: "1em",
                fontFamily: "appFontBold",
                marginBottom: "1vh",
                color: !!error ? "red" : undefined,
              }}
            >
              {title}
            </span>
            <span
              style={{
                width: "100%",
                textAlign: "center",
                fontSize: "0.8em",
                fontFamily: "appFontBold",
              }}
            >
              {msg}
            </span>
          </div>
          {/* <img src={logo} style={{height:208/2,width:1068/2,alignSelf:"center",display:"flex",marginBottom:"60px"}} className="App-logo" alt="logo" /> 
    <span style={{width:"40%",textAlign:"center"}}>Connecting Athletes to Mental Health Professionals at you fingertips.</span> */}
        </div>
      </div>
    </div>
  );
}

function EmailUs({ index }: any) {
  return (
    <div
      style={{
        width: "100vw",
        marginTop: "32px",
        marginBottom: "80px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <span style={{ flex: 0, whiteSpace: "nowrap", fontSize: "1.5em" }}>
        Write to Us
      </span>
      <div
        style={{
          minWidth: "20vw",
          paddingLeft: "4vmax",
          paddingRight: "4vmax",
          marginTop: "2vh",
          height: "4vh",
          backgroundColor: "rgba(255,255,255,0.75)",
          borderRadius: 25,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-evenly",
          padding: "1vmax",
        }}
      >
        <p style={{ fontSize: "3vmin" }}>info@gameonappllc.com</p>
      </div>
    </div>
  );
}

function Footer() {
  return (
    <div
      style={{
        width: "100vw",
        height: "44px",
        backgroundColor: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "20px",
      }}
    >
      <span style={{ fontSize: "0.5em" }}>Copyright (c) 2022 Game On! LLC</span>
    </div>
  );
}

export default Response;
